<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="650px"
    center
    @close="dialogClose"
    :close-on-click-modal="false">
    <div class="depart">
      <el-form :model="companyData" label-width="100px" :rules="rules" ref="ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="委托商：" style="margin-top: 10px; margin-bottom: 10px" prop="consignorName">
              <el-select
                v-model="companyData.consignorName" filterable :disabled="disabled"  size="small" style="width: 100%"
                placeholder="请选择委托商" value-key="id"  @change="getConsignor">
                <el-option
                  v-for="item in consignorList" :key="item.id"
                  :label="item.customer_name" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="供应商类型：" style="margin-top: 10px" prop="type" label-width="130px">
              <el-radio-group
                :disabled="disabled"
                @change="supplierName(companyData.type)"
                v-model="companyData.type">
                <el-radio :label="0">公路</el-radio>
                <el-radio :label="1">水路</el-radio>
                <el-radio :label="2">港口及其他</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="供应商："  prop="supplierName">
              <el-select
                v-model="companyData.supplierName" size="mini" filterable clearable :disabled="disabled"
                style="width: 100%" placeholder="请选择供应商" value-key="id" @change="getSupplier">
                <el-option
                  v-for="item in supplierList" :key="item.id"
                  :label="item.name" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label='品牌：' prop='brandNames'>
              <el-select v-model='companyData.brandNames' size='mini' filterable style='width:100%'
                         multiple @change='changeSelect' placeholder='请选择品牌' value-key='id'>
                <el-checkbox class='my-checkbox' v-model='checked' @change='selectAll'>全选
                </el-checkbox>
                <el-option v-for='item in brandOptions' :key='item.id'
                           :label='item.brand' :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="开始日期：" prop="startDate" style="margin-bottom: 20px">-->
<!--              <el-date-picker-->
<!--                v-model="companyData.startDate"-->
<!--                size="small"-->
<!--                type="datetime"-->
<!--                style="width: 100%"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                placeholder="请选择有效开始时间" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="结束日期：" prop="endDate">-->
<!--              <el-date-picker-->
<!--                v-model="companyData.endDate"-->
<!--                size="small"-->
<!--                type="datetime"-->
<!--                style="width: 100%"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                placeholder="请选择有效结束时间"-->
<!--                default-time="23:59:59"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定
          </el-button>
          <el-button size="medium" class="resetBtn" @click="dialogClose">取消</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import {customerInfoSelectList, getHighwayParam} from "@/service/basicfile";
import {contractPageList, highwayLineSelectWaterSupplier} from "@/service/financial";
import {getModelList} from "@/service/vehiclelog";
import {
  addRevenue,
  detailRevenue,
  getSupplierPortOtherInfo,
  updateRevenue
} from "@/service/warehouse";

export default {
  data(){
    return{
      dialogTitle: '',
      dialogVisible: false,
      companyData:{
        consignorName: '',
        supplierName: '',
        type: '',
        brandNames: [],
        startDate: '',
        endDate: ''
      },
      consignorList: [],
      supplierList: [],
      brandOptions: [],
      disabled: false,
      addLoad: false,
      checked: false,
      rules: {
        consignorName: [
          {
            required: true,
            message: '请选择委托商',
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: '请选择供应商类型',
            trigger: 'blur',
          },
        ],
        supplierName: [
          {
            required: true,
            message: '请选择供应商',
            trigger: 'blur',
          },
        ],
        brandNames: [
          {
            required: true,
            message: '请选择品牌',
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: true,
            message: '请选择开始日期',
            trigger: 'blur',
          },
        ],
        endDate: [
          {
            required: true,
            message: '请选择结束日期',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getCustomerInfoSelectList()
    this.getBrand()
  },
  methods:{
    async dialogOpen(title, row) {
      this.dialogTitle = title;
      if(title == '修改'){
        this.disabled = true
        let brandIdsArray = row.brandIds.split(',');
        let uniqueBrandIds = Array.from(new Set(brandIdsArray));
        this.companyData = {
          ...row,
         brandNames :uniqueBrandIds,
          consignorName: {
            id: row.consignorId,
            customer_name: row.consignorName
          },
          supplierName: {
            id: row.supplierId,
            name: row.supplierName
          }
        }
        await this.getCustomerInfoSelectList()
        await this.supplierName(row.type)
        await this.getBrand()
      }
      this.dialogVisible = true;
    },
    dialogClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields()
    },
    getConsignor(){
      this.$forceUpdate()
    },
    getSupplier(){
      this.$forceUpdate()
    },
    //获取供应商
    async supplierName(type) {
      if (type == 0) {
        const res = await getHighwayParam('');
        this.supplierList = res.data;
      } else if (type == 1) {
        const res = await highwayLineSelectWaterSupplier('');
        this.supplierList = res.data;
      }else {
        const res = await getSupplierPortOtherInfo('');
        this.supplierList = res.data.map(item =>{
          return {
            id: item.id,
            name: item.supplierName
          }
        })
      }
    },
    // 获取委托商
    async getCustomerInfoSelectList() {
      const {
        status,
        message,
        data,
      } = await customerInfoSelectList();
      if (status !== 0) return this.$message.warning(message);
      this.consignorList = data;
    },
    // 获取品牌
    async getBrand() {
      const {
        status,
        message,
        data,
      } = await getModelList();
      if (status !== 0) return this.$message.warning(message);
      this.brandOptions = data;
    },
    selectAll() {
      this.companyData.brandNames = [];
      if (this.checked) {
        this.brandOptions.map((item) => {
          this.companyData.brandNames.push(item.id);
        });
      } else {
        this.companyData.brandNames = [];
      }
    },
    changeSelect(val) {
      this.checked = val.length === this.brandOptions.length;
    },
    addClick(){
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let data;
          if (this.companyData.id) {
            this.addLoad = true
            data = await updateRevenue({
              id: this.companyData.id,
              consignorName: this.companyData.consignorName.customer_name,
              consignorId: this.companyData.consignorName.id,
              brandNames: this.companyData.brandNames.map(brandId => {
                const brand = this.brandOptions.find(option => option.id === brandId);
                return brand ? brand.brand : null;
              }).join(','),
              brandIds: this.companyData.brandNames.join(','),
              supplierName: this.companyData.supplierName.name,
              supplierId: this.companyData.supplierName.id,
              type: this.companyData.type,
              startDate: this.companyData.startDate,
              endDate: this.companyData.endDate,
              isDel: 0,
            });
            this.addLoad = false
          } else {
            this.addLoad = true
            data = await addRevenue({
              consignorName: this.companyData.consignorName.customer_name,
              consignorId: this.companyData.consignorName.id,
              brandNames: this.companyData.brandNames.map(brandId => {
                const brand = this.brandOptions.find(option => option.id === brandId);
                return brand ? brand.brand : null;
              }).join(','),
              brandIds: this.companyData.brandNames.join(','),
              supplierName: this.companyData.supplierName.name,
              supplierId: this.companyData.supplierName.id,
              type: this.companyData.type,
              startDate: this.companyData.startDate,
              endDate: this.companyData.endDate,
              isDel: 0,
            });
            this.addLoad = false
          }
          if (data.status !== -1) return this.$message.error(data.message);
          this.$message.success(data.message);
          this.$emit('searchBtn');
          this.dialogClose();
        }
      });
    }
  }
}
</script>


<style scoped lang="scss">

</style>
